<template>
    <v-container>
      <loader-dialog :showLoader="loading" message="Carregando entidades..."/>
      <header-for-list-component
        sectionName="Entidades"
        :items="activeItems"
        :totalItems="totalItems"
        :totalPages="totalPages"
        :itemsPerPage="itemsPerPage"
        :pageNumber.sync="pageNumber"
        @loadPage="loadPage($event)"
      />
  
  
      <v-layout align-center class="mb-4">
        <v-flex xs4>
          <v-text-field
            v-model="search"
            solo
            label="Buscar Entidade"
            prepend-inner-icon="search"
            hide-details
            :loading="loadingSearch"
            @input="typing()"
          >
            <template v-slot:progress>
              <v-progress-linear
                v-if="loadingSearch"
                color="accent"
                indeterminate
                height="3"
              ></v-progress-linear>
            </template>
          </v-text-field>
        </v-flex>
        <v-flex xs8></v-flex>
        <v-flex>
          <v-btn flat color="docgo" @click="newEntityDialog = true">
            <v-icon class="pr-2">
              mdi-account-multiple-plus
            </v-icon>
            Nova Entidade
          </v-btn>
        </v-flex>
      </v-layout>
  
      <v-layout>
        <v-flex xs12>
          <v-card>
            <div v-if="activeItems.length === 0">
              <h4 style="text-align: center" class="pa-3">Nenhuma entidade encontrada com o termo buscado</h4>
            </div>
  
            <v-data-table
              v-else
              :headers="headers"
              :items="activeItems"
              hide-actions
              class="elevation-1"
            >
              <template v-slot:items="props">
                <tr style="cursor: default">
                  <td>
                    <span class="">{{ props.item.name }}</span>
                  </td>
                  <td>
                    <span class="">{{ formatCpfCnpj(props.item.cpf_cnpj) }}</span>
                  </td>
                  <td>
                    <span class="">{{ props.item.email }}</span>
                  </td>
                  <td>
                    <span class="">{{ props.item.address }}</span>
                  </td>
                  <td class="text-xs-right action-icons">
                    <v-layout class="d-inline-flex">
                      <v-btn
                        icon
                        flat
                        class="mx-0"
                        @click.stop="editEntity(props.item)"
                      >
                        <v-icon small>
                          mdi-pencil
                        </v-icon>
                      </v-btn>
                    </v-layout>
                  </td>
                </tr>
              </template>
            </v-data-table>
  
            <new-entity-dialog
              :show="newEntityDialog"
              :editMode="editMode"
              :entityToEdit="entityToEdit"
              @close="onDialogClosed"
              @entitySaved="onEntitySaved"
              @entityUpdated="onEntityUpdated"
            />
          </v-card>
        </v-flex>
      </v-layout>
  
    </v-container>
  </template>
  
  <script>
    import HeaderForListComponent from "@/components/settings/HeaderForListComponent";
    import LoaderDialog from '@/components/LoaderDialog';
    import entityService from '@/services/EntityService';
    import NewEntityDialog from '@/components/folder/new/NewEntityDialog';
  
    export default {
      components: {
        LoaderDialog,
        HeaderForListComponent,
        NewEntityDialog,
      },
      name: "entities",
      data() {
        return {
          headers: [
            {text: 'Nome', sortable: true, value: 'name', align: 'left'},
            {text: 'CPF/CNPJ', sortable: false, value: 'cpf_cnpj', align: 'left'},
            {text: 'Email', sortable: false, value: 'email', align: 'left'},
            {text: 'Address', sortable: false, value: 'address', align: 'left'},
          ],
          activeItems: [],
          newEntityDialog: false,
          loading: false,
          loadingSearch: false,
          totalItems: 0,
          totalPages: 0,
          itemsPerPage: 20,
          pageNumber: 1,
          search: '',
          interval: null,
          editMode: false,
          entityToEdit: null,
        };
      },
      mounted() {
        this.loadPage(1);
      },
      methods: {
        loadPage(pageNumber) {
          this.pageNumber = pageNumber || this.pageNumber;
          if (!this.loadingSearch) this.loading = true;
  
          entityService.all({
            limit: this.itemsPerPage,
            page: this.pageNumber,
            q: this.search,
          })
            .then(({data}) => {
              this.activeItems = data.entities;
              this.totalItems = data.total;
              this.totalPages = data.total_pages;
            })
            .catch(({response}) => {
              this.$store.dispatch('toggleSnackbar', {
                show: true,
                timeout: 6000,
                color: 'error',
                message: response.data,
                messageIcon: 'mdi-check',
              });
            })
            .finally(() => {
              this.loading = false;
              this.loadingSearch = false;
            });
        },
        formatCpfCnpj(cpfCnpj) {
          if (cpfCnpj.length === 11) {
            return cpfCnpj.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
          } else if (cpfCnpj.length === 14) {
            return cpfCnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
          } else {
            return cpfCnpj;
          }
        },
        typing() {
          clearInterval(this.interval)
          this.interval = setTimeout(() => {
            this.loadingSearch = true;
            this.pageNumber = 1;
            this.loadPage();
          }, 500);
        },
        editEntity(entity) {
          this.editMode = true;
          this.entityToEdit = entity;
          this.newEntityDialog = true;
        },
        onEntitySaved({ entity }) {
          this.activeItems.push(entity);
          this.onDialogClosed();
        },
        onEntityUpdated({ entity }) {
          const index = this.activeItems.findIndex(item => item.id === entity.id);
          if (index !== -1) {
            this.$set(this.activeItems, index, entity);
          }
          this.onDialogClosed();
        },
        onDialogClosed() {
          this.newEntityDialog = false;
          this.editMode = false;
          this.entityToEdit = null;
        }
      }
    };
  </script>
  
  <style lang="scss" scoped>
    .inactive{
      & > * {
        text-decoration: line-through;
      }
    }
  
    .action-icons{
      text-decoration: none !important;
    }
  </style>
  


// WEBPACK FOOTER //
// src/views/settings/entities/List.vue